import { put, call, takeEvery, select } from 'redux-saga/effects';
import moment from 'moment';
import * as actions from './actions';
import { getSalesOwnerId } from '../reservation/selectors';

export const getLangState = state => state.lang;

export function* getState() {
  return yield select(getLangState);
}

export function* downloadLanguage(api, language, salesOwnerId) {
  const url = `/cms/${language}?salesOwnerId=${salesOwnerId}`;
  let result = null;
  try {
    result = yield call([api, api.get], url);
    yield put(actions.addTranslations(language, result));
  } catch (e) {
    // .
  }
  return result;
}

export const getReservationState = state => state.reservation;

export function* watchLanguageChange(api, { payload }) {
  const langState = yield getState();
  const reservationState = yield select(getReservationState);
  const salesOwnerId = getSalesOwnerId(reservationState);
  if (!langState.translations[payload.language]) {
    yield downloadLanguage(api, payload.language, salesOwnerId);
  }
}

export function* getLanguagesBySalesOwner(api, { payload: { salesOwnerId } }) {
  const url = `/cms/get-languages?salesOwnerId=${salesOwnerId}`;
  let result = null;
  try {
    result = yield call([api, api.get], url);
    yield put(actions.addLanguages(result));
  } catch (e) {
    // .
  }
  return result;
}

const setMomentLocale = (locale) => {
  try {
    require(`moment/locale/${locale}`);
    return true;
  } catch (e) {
    return false;
  }
};

export function* watchMomentLocale(api, { payload: { language } }) {
  const localesToTry = [language.substring(0, 2), language.substring(0, 5)];
  for (let i = 0; i < localesToTry.length; i += 1) {
    const locale = localesToTry[i];
    const success = yield call(setMomentLocale, locale.toLowerCase());
    if (success) {
      moment.locale(locale);
      yield put({ type: 'MOMENT_LOCALE_CHANGED', payload: { locale } });
      break;
    }
  }
}

export default function* ({ api }) {
  yield takeEvery(actions.CHANGE_LANGUAGE, watchLanguageChange, api);
  yield takeEvery(actions.CHANGE_LANGUAGE, watchMomentLocale, api);
  yield takeEvery(actions.GET_LANGUAGES, getLanguagesBySalesOwner, api);
}



// WEBPACK FOOTER //
// ./src/store/lang/sagas.js